
import axiosClient from "../../../../api/axiosClient";

// ======================================================================
// API BASE URL
// ======================================================================

const BASE_URL = "/api/assets/certificate-management";

// ======================================================================
// CERTIFICATE TYPES
// ======================================================================

async function listCertificateTypes(filters = {}) {
    const response = await axiosClient.get(
        `${BASE_URL}/types`,
        { params: filters }
    );

    return response.data.data;
}

async function getCertificateType(typeId) {
    const response = await axiosClient.get(
        `${BASE_URL}/types/${typeId}`
    );

    return response.data.data;
}

async function createCertificateType(payload) {
    const response = await axiosClient.post(
        `${BASE_URL}/types`,
        payload
    );

    return response.data.data;
}

const setCertificateActive = async (certificateId, isActive) => {
  const response = await axiosClient.patch(
    `${BASE_URL}/${certificateId}/status`,
    { is_active: isActive }
  );

  return response.data.data;
};

async function updateCertificateType(typeId, payload) {
    const response = await axiosClient.put(
        `${BASE_URL}/types/${typeId}`,
        payload
    );

    return response.data.data;
}

async function deleteCertificateType(typeId) {
    const response = await axiosClient.delete(
        `${BASE_URL}/types/${typeId}`
    );

    return response.data;
}

// ======================================================================
// CERTIFICATE REGISTER
// ======================================================================

async function listCertificates(filters = {}) {
    const response = await axiosClient.get(
        BASE_URL,
        { params: filters }
    );

    return response.data.data;
}

async function getCertificate(certificateId) {
    const response = await axiosClient.get(
        `${BASE_URL}/${certificateId}`
    );

    return response.data.data;
}

async function createCertificate(payload) {
    const response = await axiosClient.post(
        BASE_URL,
        payload
    );

    return response.data.data;
}


async function uploadCertificateDocument(certificateId, file, remarks = "") {
    const formData = new FormData();

    formData.append("file", file);
    formData.append("remarks", remarks);

    const response = await axiosClient.post(
        `${BASE_URL}/${certificateId}/documents/upload`,
        formData,
        {
            headers: {
                "Content-Type": undefined,
            },
        }
    );

    return response.data.data;
}


async function downloadCertificateDocument(certificateId) {
    const response = await axiosClient.get(
        `${BASE_URL}/${certificateId}/documents/download`,
        {
            responseType: "blob",
        }
    );

    const blobUrl = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");

    link.href = blobUrl;
    link.download = `certificate-${certificateId}`;
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(blobUrl);
}

async function updateCertificate(certificateId, payload) {
    const response = await axiosClient.put(
        `${BASE_URL}/${certificateId}`,
        payload
    );

    return response.data.data;
}

async function getCertificateDocument(certificateId) {
    const response = await axiosClient.get(
        `${BASE_URL}/${certificateId}/documents`
    );

    return response.data.data;
}
async function deleteCertificate(certificateId) {
    const response = await axiosClient.delete(
        `${BASE_URL}/${certificateId}`
    );

    return response.data;
}

// ======================================================================
// EXPORT
// ======================================================================

const certificateService = {
    // Certificate Types
    listCertificateTypes,
    getCertificateType,
    createCertificateType,
    updateCertificateType,
    deleteCertificateType,

    // Certificate Register
    listCertificates,
    getCertificate,
    createCertificate,
    uploadCertificateDocument,
    downloadCertificateDocument,
    getCertificateDocument,
    updateCertificate,
    deleteCertificate,
    setCertificateActive,
};

export default certificateService;
